// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingScreen_root__1mFQO","inner":"LoadingScreen_inner__1WBWO","loadingImg":"LoadingScreen_loadingImg__8BC3D","loadingMsg":"LoadingScreen_loadingMsg__32ChP"};